module.exports = __webpack_public_path__ + "static/img/t3.8f37277.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/t3.png
// module id = YUPn
// module chunks = 2